module.exports = __webpack_public_path__ + "img/Screen Shot 2021-04-18 at 6.55.16 PM.ce299b69.png";